export default class Tabs {
  constructor(tabBtnSelector, tabSelector, activeClass) {
    this.tabBtnSelector = tabBtnSelector;
    this.tabBtns = document.querySelectorAll(tabBtnSelector);
    this.tabSelector = tabSelector;
    this.activeClass = activeClass;
    this.init();
  }

  switchClassActive(elementSelector, element) {
    document.querySelector(`${elementSelector}.active`).classList.remove(this.activeClass);
    element.classList.add(this.activeClass);
  }

  init() {
    this.tabBtns.forEach((tabBtn) => {

      tabBtn.addEventListener('click', (event) => {
        event.preventDefault();
        const targetTabId = event.target.getAttribute("href"),
          targetTab = document.querySelector(targetTabId);

        this.switchClassActive(this.tabBtnSelector, event.target);
        this.switchClassActive(this.tabSelector, targetTab);
      });
    });
  }

}
